/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Trust_Window_Scope_GlobalInputs */



/**
* | output |
* | --- |
* | "all hosts" |
*
* @param {Audit_Details_Trust_Window_Scope_GlobalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_trust_window_scope_global = /** @type {((inputs?: Audit_Details_Trust_Window_Scope_GlobalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Trust_Window_Scope_GlobalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("alle Hosts")
	return /** @type {LocalizedString} */ ("all hosts")
});